import { ArrowLeft } from 'lucide-react';
import { IconButton } from '../atoms/Button';

/**
 * PageHeader — page title block with optional back button, icon, subtitle
 * and right-aligned actions. Replaces the per-page
 * `dashboard-page__toolbar` / `__greeting` copies.
 */
export default function PageHeader({
  title,
  subtitle,
  icon: Icon,
  onBack,
  backLabel = 'Kembali',
  actions,
  className = '',
}) {
  return (
    <div className={`page-header dashboard-page__toolbar ${className}`.trim()}>
      <div className="page-header__main">
        {onBack && (
          <IconButton
            icon={ArrowLeft}
            variant="ghost"
            size="sm"
            title={backLabel}
            aria-label={backLabel}
            onClick={onBack}
          />
        )}
        <div className="dashboard-page__greeting">
          <h2 className="page-header__title">
            {Icon && <Icon size={22} aria-hidden="true" />}
            {title}
          </h2>
          {subtitle && <p>{subtitle}</p>}
        </div>
      </div>
      {actions && <div className="page-header__actions">{actions}</div>}
    </div>
  );
}
